import isNil from 'lodash/isNil';
import isObject from 'lodash/isObject';
import moment from 'moment';

import { CcmCampaignTimeline } from '../types';

export const EIGHT_DAY_WITH_A_WEEK_IN_BETWEEN = 8;

export const isCcmCampaignTimeline = (
  input: unknown
): input is CcmCampaignTimeline => (
  !isNil(input)
    && isObject(input)
    && 'campaignStartDate' in input
    && 'campaignEndDate' in input
    && 'moderatorsApproveUntil' in input
    && 'influencersSignInStartDate' in input
    && 'influencersSignInEndDate' in input
    && 'influencersSubmitOutfitsFrom' in input
    && 'influencersSubmitOutfitsUntil' in input
    && 'taskContentApprovalStartDate' in input
    && 'taskContentApprovalEndDate' in input
    && 'taskContentGoLiveDate' in input
    && 'taskContentGoLiveEndDate' in input
);

export const isGoLiveDateReached = (
  timeline?: CcmCampaignTimeline | null
): boolean => {
  const goLiveDate = moment.utc(timeline?.taskContentGoLiveDate).startOf('day');
  const today = moment.utc().startOf('day');

  return today.isSameOrAfter(goLiveDate, 'day');
};

export const isInfluencerSignInDateReached = (
  timeline?: CcmCampaignTimeline | null
): boolean => {
  const influencerSignInDate = moment.utc(timeline?.influencersSignInStartDate).startOf('day');
  const today = moment.utc().startOf('day');

  return today.isSameOrAfter(influencerSignInDate, 'day');
};
